import { render, staticRenderFns } from "./InvitacionesCopiadasModal.vue?vue&type=template&id=78a4c24e"
import script from "./InvitacionesCopiadasModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesCopiadasModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports